import { useAuth } from "../contexts/AuthContext";

interface FormInfoHeaderProps {
  title: string;
  published: boolean;
  estimatedTime: number | null;
  isLoadingEstimatedTime: boolean;
  estimatedTimeErrorMessage?: string;
}

export function FormInfoHeader({
  title,
  published,
  estimatedTime,
  isLoadingEstimatedTime,
  estimatedTimeErrorMessage,
}: FormInfoHeaderProps) {
  const { isAdmin } = useAuth();
  return (
    <div className="bg-gradient-to-br from-blue-50 to-indigo-50 border border-blue-200 rounded-xl p-4 relative overflow-hidden">
      <div className="absolute top-0 right-0 w-20 h-20 bg-gradient-to-br from-blue-400/10 to-indigo-400/10 rounded-full -translate-y-8 translate-x-8"></div>
      <div className="flex items-start justify-between mb-4 relative">
        <div className="flex-1">
          <h3 className="text-lg font-semibold text-gray-900 mb-1">{title}</h3>
        </div>
        {isAdmin ? (
          <span
            className={`text-xs px-3 py-1.5 rounded-full flex-shrink-0 font-medium shadow-sm ${published
              ? "bg-green-100 text-green-700 border border-green-200"
              : "bg-amber-100 text-amber-700 border border-amber-200"
              }`}
          >
            {published ? "✓ Published" : "○ Draft"}
          </span>
        ) : (
          <span className="text-xs px-3 py-1.5 rounded-full flex-shrink-0 font-medium shadow-sm bg-green-100 text-green-700 border border-green-200">
            Pending
          </span>
        )}
      </div>

      <div className="grid grid-cols-2 gap-3 relative">
        <div className="bg-white/80 backdrop-blur-sm border border-blue-200/50 rounded-lg p-3 shadow-sm">
          <p className="text-xs text-blue-600 mb-1 font-medium">Est. Time</p>
          {isLoadingEstimatedTime ? (
            <div className="h-4 w-16 bg-gray-200 rounded animate-pulse" />
          ) : estimatedTime == null ? (
            <div>
              <p className="text-sm font-semibold text-gray-400">—</p>
              {estimatedTimeErrorMessage && (
                <p className="text-[11px] text-red-500 mt-1">
                  {estimatedTimeErrorMessage}
                </p>
              )}
            </div>
          ) : (
            <p className="text-sm font-semibold" style={{ color: "var(--color-primary)" }}>
              {estimatedTime} min
            </p>
          )}
        </div>
      </div>
    </div>
  );
}

export default FormInfoHeader;
